import api from "api/axios";

// DRCFO Admin Advisory Templates — the Advisory templates DRCFO publishes per
// speciality. Stored as ordinary Advisory templates (drcfo.backend
// `prescriptions`, genratedBy "admin"); doctors read the published ones for
// their speciality through their own Templates Master, read-only.
const BASE = "/admin/advisory-templates";

export const getAdvisoryTemplates = (params) => api.get(BASE, { params });

export const getAdvisoryTemplate = (id) => api.get(`${BASE}/${id}`);

export const createAdvisoryTemplate = (payload) => api.post(BASE, payload);

export const updateAdvisoryTemplate = (id, payload) =>
  api.put(`${BASE}/${id}`, payload);

export const setAdvisoryTemplateStatus = (id, templateStatus) =>
  api.patch(`${BASE}/${id}/status`, { templateStatus });

export const deleteAdvisoryTemplate = (id) => api.delete(`${BASE}/${id}`);

export const importAdvisoryTemplates = (file) => {
  const body = new FormData();
  body.append("file", file);
  return api.post(`${BASE}/import`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/** kind = "template" | "export" */
export const downloadAdvisoryTemplateFile = (kind, params) =>
  api.get(`${BASE}/${kind}`, { params, responseType: "blob" });
